import * as F from 'reduker/fp-utils'
import entities from 'reduker/entities'
import request from 'reduker/request'

import pick from 'utils/pick'
import { PAGE_LIMIT } from './constants'

export const getSelectedIds = state => state.vendors.selectedIds
export const getVendorsList = state => state.vendors.list
export const getPaginationInfo = state => state.vendors.pagination
export const getVendorsIds = F.pipe(getVendorsList, Object.keys)

export const getSelectedIdsOnPage = state => {
  const selectedIds = getSelectedIds(state)
  const vendorsKeys = getVendorsIds(state)

  return pick(selectedIds, vendorsKeys)
}

export const getVendorsInfo = F.pipe(
  state => state.vendors.list,
  entities.getAsList,
  vendors => vendors.slice(0, PAGE_LIMIT),
)

export const getVendorsRequest = state => state.vendors.request

export const getIsVendorsFetching = F.pipe(
  getVendorsRequest,
  request.getIsRequesting,
)

export const getVendorsError = F.pipe(getVendorsRequest, request.getError)

export const getAddVendorRequest = state => state.vendors.addVendorRequest
export const getIsAddVendorFetching = F.pipe(
  getAddVendorRequest,
  request.getIsRequesting,
)
export const getAddVendorError = F.pipe(getAddVendorRequest, request.getError)
export const getIsAddVendorSucceeded = F.pipe(
  getAddVendorRequest,
  request.getIsRequestSucceeded,
)
export const getIsNotRegistered = state => {
  const error = getAddVendorError(state)
  return error && error.notRegistered
}
export const getIsAddVendorConfirmed = state => state.vendors.addVendorConfirmed

export const getSearchOptions = state => state.vendors.searchOptions

export const getSearchFilters = state => state.vendors.searchFilters

export const getCurrentPage = state => state.vendors.pagination.page
